import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { GlobalSearch } from './GlobalSearch';
import { Button } from '../ui/button';
import { Clock, LogOut, Mail } from 'lucide-react';

export const MainLayout = () => {
  const { isAuthenticated, loading, user, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse">
          <div className="w-12 h-12 bg-lime rounded-lg"></div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Show pending approval screen for users awaiting approval
  if (user?.status === 'pending') {
    return (
      <div className="min-h-screen bg-secondary flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <Clock className="w-8 h-8 text-yellow-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Account Pending Approval</h1>
          <p className="text-gray-600 mb-4">
            Your Technofocus account has been created and is awaiting administrator approval.
            You will be able to access Skilltrac once approved.
          </p>
          <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm font-medium text-gray-700 mb-1">Logged in as:</p>
            <p className="text-sm text-gray-900 font-semibold">{user?.name}</p>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500 justify-center mb-6">
            <Mail className="w-4 h-4" />
            <span>Contact: <a href="mailto:ranjana.jain@technofocus.in" className="text-blue-600 hover:underline">ranjana.jain@technofocus.in</a></span>
          </div>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => {
              logout();
              window.location.href = '/login';
            }}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Sidebar />
      <div className="ml-64 flex flex-col min-h-screen">
        <div className="sticky top-0 z-40 bg-background/95 backdrop-blur border-b border-border" data-testid="top-bar">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 h-14 flex items-center">
            <GlobalSearch />
          </div>
        </div>
        <main className="flex-1">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
